/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DateDisplay from 'app/components/common/DateDisplay.jsx';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from "underscore";
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputLogPanel extends React.Component {
    constructor(props) {
        super(props);

        let inputId = 0,
            inputLog = [];

        if (props.router.params && props.router.params.inputId) {
            inputId = props.router.params.inputId;
        }

        if (inputId !== 0 && props.log === undefined) {
            if (props.app.firstLoad.ROUTE_LIST === true) {
                props.fetchInputLog(inputId);
            }
        }

        if (props.log !== undefined) {
            inputLog = props.log;
        }

        this.state = {
            inputId: inputId,
            inputLog
        };

    }

    static getDerivedStateFromProps(props, state) {

        if (props.router.params && props.router.params.inputId) {
            if (parseInt(props.router.params.inputId, 10) !== parseInt(state.inputId, 10)) {
                return {
                    inputId: props.router.params.inputId
                };
            }
        }

        return null;

    }

    componentDidUpdate(prevProps, prevState) {

        // if (prevState.inputId != this.state.inputID && this.state.inputId !== 0) {
        //     this.props.fetchInputLog(this.state.inputId);
        // }

        if (prevProps.app.firstLoad.ROUTE_LIST === false && this.props.app.firstLoad.ROUTE_LIST === true) {
            this.props.fetchInputLog(this.state.inputId);
        }

    }

    render() {

        let errorBlock = null,
            adviceBlock = null,
            logBlock = null,
            logs = [],
            terminalLogs = [];


        if (this.props.log === undefined) {
            for (let i = 0; i < this.props.automatedRoutes.logs.length; ++i) {
                if (parseInt(this.state.inputId, 10) === parseInt(this.props.automatedRoutes.logs[i].id)) {
                    logs = this.props.automatedRoutes.logs[i].log;
                    break;
                }
            }
        } else {
            logs = this.props.log;
        }

        if (logs.length) {
            terminalLogs = _.where(logs, {success: 0});
            terminalLogs = _.sortBy(terminalLogs, 'unixTs').reverse();
        }

        // no log entries if the input has been deactivated/inaccessible for more than
        // a few days
        if (this.props.configLoaded === false || this.props.userLoaded === false || this.props.app.loading.INPUT_LOG) {
            logBlock = <Loading/>;
        } else if (terminalLogs.length === 0 && logs.length === 0) {
            logBlock = (
                <div className="log-advice">
                    {"This feed has been inactive for a few days or more — there is no activity to show"}
                </div>
            );
        } else {

            if (terminalLogs.length) {
                adviceBlock = (
                    <div className="log-advice">
                        For tips on diagnosing problems with your feed, see the <a className="faq-link" href="https://support.dlvrit.com/hc/en-us/articles/115000020754-What-does-my-error-message-mean-" target="_blank">Feed FAQ.</a>
                    </div>
                );
            }

            if (logs.length) {
                logBlock = (
                    <ul className="log-list">
                        {logs.map(function(log){
                            let logEntryClass = classnames('log-entry', {
                                'error': (log.success === 0)
                            });

                            return (
                                <li className={logEntryClass} key={log.unixTs}>
                                    <div className="log-date">
                                        <DateDisplay
                                            dateTime={log.unixTs * 1000}
                                            dateTimeFormat="long"
                                            useTimezone={true}
                                            user={this.props.user}
                                            withRelative={true}
                                        />
                                    </div>
                                    <div className="log-message">
                                        {log.message}
                                    </div>
                                </li>
                            );
                        }, this)}
                    </ul>
                )
            }
        }

        return (
            <div>
                {errorBlock}
                {adviceBlock}
                {logBlock}
            </div>
        );

    }

};

InputLogPanel.displayName = "InputLogPanel";

export default ComponentWithContext(InputLogPanel);
